import { useRef, useState } from 'react';
import { UMButton, UMMessage, UMR, UMStack } from '../../../urbanmap/_components';

interface FileState { name?: string; error?: string }
export function useBuildingUpload() {
  const [files, setFiles] = useState<Record<string, FileState>>({});
  const choose = (selectionId: string, fileName: string | undefined) => {
    if (fileName === undefined) return;
    setFiles((prev) => ({ ...prev, [selectionId]: /\.(xlsx|xls)$/i.test(fileName)
      ? { name: fileName }
      : { ...prev[selectionId], error: 'Format invalide. Choisissez un fichier Excel (.xlsx ou .xls).' } }));
  };
  return { files, choose };
}

export function BuildingUpload({ state, onChoose, disabled }: {
  state?: FileState; onChoose: (name: string | undefined) => void; disabled: boolean;
}) {
  const input = useRef<HTMLInputElement>(null);
  return <UMStack>
    <UMButton disabled={disabled} onClick={() => input.current?.click()}>Charger un fichier Excel</UMButton>
    <UMMessage>Simulation : le fichier Excel a été chargé. Aucun bâtiment n’a été modifié.</UMMessage>
    {/* Native file picker only: Fluid/UM has no file-picker equivalent. No file content is read. */}
    <input ref={input} type="file" accept=".xlsx,.xls" disabled={disabled}
      aria-label="Fichier Excel des bâtiments" style={{ display: 'none' }}
      onChange={(event) => {
        const name = event.target.files?.[0]?.name;
        event.target.value = '';
        if (!disabled) onChoose(name);
      }} />
    <div role="status" aria-live="polite" style={{ fontSize: 12, color: UMR.textMuted, overflowWrap: 'anywhere' }}>
      {state?.name && <>
        <div>Fichier : {state.name}</div>
        <div>Chargement simulé — aucun bâtiment modifié.</div>
      </>}
      {state?.error && <div role="alert">{state.error}</div>}
    </div>
  </UMStack>;
}
